export const ResponsiveToolBar = {
  DeviceButtonSet: {
    flow: 'row-reverse',
  },
  ThreeDots: {
    extends: [
      'ClickableItem',
      'SquareButton',
    ],
    icon: 'threeDots vertical',
  },
  flow: 'x',
  gap: 'A',
};